import React, { useState } from "react";

export function DecimalInput({
  value,
  onChange,
  placeholder,
  min,
  max,
  percentage,
}: {
  value: string;
  onChange: (e: string) => void;
  placeholder?: string;
  min?: number | false;
  max?: number | false;
  percentage: boolean;
}) {
  const [showError, setShowError] = useState<false | string>(false);
  return (
    <div className="flex flex-column">
      <div className="flex flex-row justify-center items-center mr-auto">
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => {
            setShowError(false);
            let result = "";
            const share = e.target.value;
            if (new RegExp("^\\d+(\\.\\d*)?(,\\d*)?$").test(share)) {
              result = share.replace(",", ".");
              if (max)
                if (parseFloat(result) > max) {
                  setShowError(`The value should be smaller than ${max}.`);
                }
              if (min)
                if (parseFloat(result) < min) {
                  setShowError(`The value should be larger than ${min}.`);
                }
            } else {
              setShowError("This field only accepts numeric input.");
            }

            onChange(result);
          }}
        />
        {percentage ? <div className="ml-5-neg">%</div> : null}
      </div>

      {showError ? <div className="red">{showError}</div> : null}
    </div>
  );
}
